import * as Immutable from 'immutable';
import ModuleBrightnessContrastSettingsContainer from '../../Module/ModuleBrightnessContrast/_containers/ModuleBrightnessContrastSettingsContainer';
import ModuleSaturationSettingsContainer from '../../Module/ModuleSaturation/_containers/ModuleSaturationSettingsContainer';
import ModuleVibranceSettingsContainer from '../../Module/ModuleVibrance/_containers/ModuleVibranceSettingsContainer';
import ModuleHueSettingsContainer from '../../Module/ModuleHue/_containers/ModuleHueSettingsContainer';
import ModuleChevronSettingsContainer from '../../Module/ModuleChevron/_containers/ModuleChevronSettingsContainer';
import ModuleCircleSettingsContainer from '../../Module/ModuleCircle/_containers/ModuleCircleSettingsContainer';
import ModuleGameboySettingsContainer from '../../Module/ModuleGameboy/_containers/ModuleGameboySettingsContainer';
import ModuleImageSettingsContainer from '../../Module/ModuleImage/_containers/ModuleImageSettingsContainer';
import ModuleKaleidoscopeSettingsContainer from '../../Module/ModuleKaleidoscope/_containers/ModuleKaleidoscopeSettingsContainer';
import ModuleNoiseSettingsContainer from '../../Module/ModuleNoise/_containers/ModuleNoiseSettingsContainer';
import ModulePixelateSettingsContainer from '../../Module/ModulePixelate/_containers/ModulePixelateSettingsContainer';
import ModulePolygonSettingsContainer from '../../Module/ModulePolygon/_containers/ModulePolygonSettingsContainer';
import ModuleRectangleSettingsContainer from '../../Module/ModuleRectangle/_containers/ModuleRectangleSettingsContainer';
import ModuleTartanSettingsContainer from '../../Module/ModuleTartan/_containers/ModuleTartanSettingsContainer';
import ModuleWallpaperGroupsSettingsContainer from '../../Module/ModuleWallpaperGroups/_containers/ModuleWallpaperGroupsSettingsContainer';
import ModulePatternDesignServiceSettingsContainer from '../../Module/ModulePatternDesignService/_containers/ModulePatternDesignServiceSettingsContainer';
import { ModuleTypes } from '../../Module/_config/ModuleInfo';
import ModuleStore, { IModuleStore } from '../../Module/_stores/ModuleStore';
import ModuleInfo from './ModuleInfo';

export const Resolve = (module:IModuleStore, callback:(className: string, settingsContainer:React.ComponentClass) => void) => {
	return ResolveFromType(module.type, callback);
}

export const ResolveFromType = (type:ModuleTypes, callback:(className: string, settingsContainer:React.ComponentClass) => void) => {
	switch(type) {
		case ModuleTypes.Image					: return callback("image", ModuleImageSettingsContainer);
		case ModuleTypes.ImageUpload			: return callback("image", ModuleImageSettingsContainer);
		case ModuleTypes.Rectangle				: return callback("rectangle", ModuleRectangleSettingsContainer);
		case ModuleTypes.Circle					: return callback("circle", ModuleCircleSettingsContainer);
		case ModuleTypes.Polygon				: return callback("polygon", ModulePolygonSettingsContainer);
		case ModuleTypes.Tartan					: return callback("tartan", ModuleTartanSettingsContainer);
		case ModuleTypes.Chevron				: return callback("chevron", ModuleChevronSettingsContainer);
		case ModuleTypes.Pixelate				: return callback("pixelate", ModulePixelateSettingsContainer);
		case ModuleTypes.Noise					: return callback("noise", ModuleNoiseSettingsContainer);
		case ModuleTypes.Kaleidoscope			: return callback("kaleidoscope", ModuleKaleidoscopeSettingsContainer);
		case ModuleTypes.BrightnessContrast		: return callback("brightness_contrast", ModuleBrightnessContrastSettingsContainer);
		case ModuleTypes.Hue					: return callback("hue", ModuleHueSettingsContainer);
		case ModuleTypes.Saturation				: return callback("saturation", ModuleSaturationSettingsContainer);
		case ModuleTypes.Vibrance				: return callback("vibrance", ModuleVibranceSettingsContainer);
		case ModuleTypes.Gameboy				: return callback("gameboy", ModuleGameboySettingsContainer);
		case ModuleTypes.WallpaperGroups		: return callback("wallpaper_groups", ModuleWallpaperGroupsSettingsContainer);
		case ModuleTypes.PatternDesignService	: return callback("pattern_design_service", ModulePatternDesignServiceSettingsContainer);
	}
}

export const hasTransformer = (module:ModuleStore):boolean => {
	return ModuleInfo[module.type].transformer;
}

type hasPositionType = ModuleStore & Immutable.Record<{x:number, y:number}>;
export const hasPosition = (module:ModuleStore):module is hasPositionType => {
	return module.has('x') && module.has('y');
}

type hasRotationType = ModuleStore & Immutable.Record<{rotation:number}>;
export const hasRotation = (module:ModuleStore):module is hasRotationType => {
	return module.has('rotation');
}

type hasDimensionsType = ModuleStore & Immutable.Record<{width:number, height:number}>;
export const hasDimensions = (module:ModuleStore):module is hasDimensionsType => {
	return module.has('width') && module.has('height');
}

type hasRadiusType = ModuleStore & Immutable.Record<{radius:number}>;
export const hasRadius = (module:ModuleStore):module is hasRadiusType => {
	return module.has('radius');
}

type hasSourceType = ModuleStore & Immutable.Record<{source:string}>;
export const hasSource = (module:ModuleStore):module is hasSourceType => {
	return module.has('source');
}

type hasSourceDimensionsType = ModuleStore & Immutable.Record<{sourceWidth:number, sourceHeight:number, sourceRatio:number}>;
export const hasSourceDimensions = (module:ModuleStore):module is hasSourceDimensionsType => {
	return module.has('sourceWidth') && module.has('sourceHeight') && module.has('sourceRatio')
}

type hasIdType = ModuleStore & Immutable.Record<{id:string}>;
export const hasId = (module:ModuleStore):module is hasIdType => {
	return module.has('id');
}